import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import { SxProps, Theme } from '@mui/material/styles';
import { floatingContainerSx } from './styles';

const BookSchoolSubscriptionMeetingButton = ({
  floating,
  sx,
  onClick,
  keepDefaultColor = false,
}: {
  floating?: boolean;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  keepDefaultColor?: boolean;
}) => {
  const { t } = useTranslation('common');
  const text = t('LANDING.BOOKMEETING');

  return (
    <>
      {floating ? (
        <Box sx={floatingContainerSx}>
          <Fab color={sx !== undefined && !keepDefaultColor ? undefined : 'primary'} onClick={onClick} sx={sx} variant={'extended'}>
            {text}
          </Fab>
        </Box>
      ) : (
        <Button color={sx !== undefined && !keepDefaultColor ? undefined : 'primary'} onClick={onClick} size={'large'} sx={sx} variant={'contained'}>
          {text}
        </Button>
      )}
    </>
  );
};

export default BookSchoolSubscriptionMeetingButton;
